import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      paddingTop: MIDDLE_MARGIN,
    },
    title: {
      fontWeight: 'bold',
      fontSize: 22,
      lineHeight: 1.2,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        cursor: 'text',
      },
    },
    itemsWrapper: {
      paddingLeft: 2,
      margin: 0,
      paddingBottom: MIDDLE_MARGIN,
    },
  }),
);

export default useStyles;
